// extracted by mini-css-extract-plugin
export default {"maxReached":"location_favorites-counter_maxReached"};